import {Component} from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    imports: [RouterLink]
})
export class PrivacyComponent {

  year: number = new Date().getFullYear();


}
